import { useState, useContext } from "react";
import {
  TextField, Button, Paper, Typography, Box, Alert, IconButton
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, Link } from "react-router-dom";
import { Brightness4, Brightness7 } from "@mui/icons-material";
import { ColorModeContext } from "../ThemeContext";
import { register } from "../api/api";

function validatePassword(password) {
  // Mínimo 8, pelo menos 1 maiúscula, 1 minúscula e 1 número
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/.test(password);
}

export default function Register() {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [success, setSuccess] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const navigate = useNavigate();
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);

  const isDark = theme.palette.mode === "dark";
  const paperBg = isDark ? "#23272f" : "#fff";
  const textColor = isDark ? "#fff" : "#23272f";

  const handleRegister = async (e) => {
    e.preventDefault();
    setMsg("");
    setPasswordError("");
    if (!validatePassword(password)) {
      setPasswordError(
        "A senha deve ter ao menos 8 caracteres, incluindo maiúscula, minúscula e número."
      );
      return;
    }
    try {
      await register(username, email, password);
      setMsg("Cadastro realizado com sucesso! Redirecionando...");
      setSuccess(true);
      setUsername(""); setEmail(""); setPassword("");
      setTimeout(() => navigate("/login"), 1700);
    } catch (err) {
      setMsg(
        err.response?.data?.error || "Erro ao cadastrar usuário."
      );
      setSuccess(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: theme.palette.background.default,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Paper
        sx={{
          p: { xs: 3, sm: 4 },
          width: { xs: 320, sm: 370 },
          maxWidth: "95vw",
          borderRadius: 4,
          bgcolor: paperBg,
          color: textColor,
          position: "relative",
          boxShadow: 6,
        }}
      >
        <IconButton
          size="small"
          onClick={colorMode.toggleColorMode}
          sx={{ position: "absolute", top: 13, right: 13 }}
        >
          {isDark ? <Brightness7 /> : <Brightness4 />}
        </IconButton>
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <img
            src="/iseq3.png"
            alt="iSEQ - Sensores & Instrumentos"
            style={{
              height: 78,
              maxWidth: "85%",
              marginBottom: 12,
              objectFit: "contain",
              filter: isDark ? "brightness(0.94)" : "none"
            }}
          />
        </Box>
        <Typography variant="h5" gutterBottom align="center" sx={{ fontWeight: 700 }}>
          Cadastro
        </Typography>
        <form onSubmit={handleRegister} autoComplete="on">
          <TextField
            fullWidth
            label="Usuário"
            margin="normal"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
            autoFocus
            InputProps={{ sx: { color: textColor } }}
            InputLabelProps={{ sx: { color: theme.palette.text.secondary } }}
            autoComplete="username"
          />
          <TextField
            fullWidth
            label="E-mail"
            margin="normal"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            InputProps={{ sx: { color: textColor } }}
            InputLabelProps={{ sx: { color: theme.palette.text.secondary } }}
            autoComplete="email"
          />
          <TextField
            fullWidth
            label="Senha"
            margin="normal"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            error={!!passwordError}
            helperText={passwordError || "Mínimo 8 caracteres, com maiúscula, minúscula e número."}
            required
            InputProps={{ sx: { color: textColor } }}
            InputLabelProps={{ sx: { color: theme.palette.text.secondary } }}
            autoComplete="new-password"
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            sx={{ mt: 2, fontWeight: 600, fontSize: 17 }}
          >
            Cadastrar
          </Button>
        </form>
        <Typography variant="body2" align="center" sx={{ mt: 2 }}>
          Já tem conta? <Link to="/login" style={{ color: theme.palette.primary.main, fontWeight: 500 }}>Faça login</Link>
        </Typography>
        {msg && (
          <Alert severity={success ? "success" : "error"} sx={{ mt: 2, textAlign: "center" }}>
            {msg}
          </Alert>
        )}
      </Paper>
    </Box>
  );
}

